import { z } from 'zod';

import { createFileRoute } from '@tanstack/react-router';

import { ProductInterface } from './-components/products-interface'; 

export const productsSearchSchema = z.object({
  displayName: z.string({ description: 'Name' }).optional(),
});

export const Route = createFileRoute('/dashboard/admin/products/')({
  component: View,

  validateSearch: productsSearchSchema,
});

function View() {
  return <ProductInterface />;
}
